// Read permissions
export const CAN_READ_USER = 'can read user';
export const CAN_READ_ROLE = 'can read role';
export const CAN_READ_PERMISSION = 'can read permission';
export const CAN_READ_SUB_PROJECT = 'can read sub-project';
export const CAN_READ_PACKAGE = 'can read package';
export const CAN_READ_FIELD_NOTE = 'can read field note';
export const CAN_READ_SAFEGUARD_CONCERN = 'can read ohs and safeguard';
export const CAN_READ_REPORT = 'can read report';
export const CAN_READ_PROJECT = 'can read project';
export const CAN_READ_PROCURING_ENTITY = 'can read procuring-entity';
//new Read Permissions
export const CAN_READ_CSC_CONTRACT = 'can read csc contract';
export const CAN_READ_DOCUMENT = 'can read document';
export const CAN_READ_EXCEPTION = 'can read exception';
export const CAN_READ_MAP = 'can read map';
export const CAN_READ_STAFF = 'can read staff';
export const CAN_READ_SETTING = 'can read setting';
export const CAN_READ_AUDIT_LOG = 'can read audit log';
export const CAN_READ_ACCESS_CONTROL = 'can read access control';
export const CAN_READ_SUBMISSION = 'can read submission';



// Create permissions
export const CAN_CREATE_PROJECT = 'can create project';
export const CAN_CREATE_SUB_PROJECT = 'can create sub-project';
export const CAN_CREATE_PACKAGE = 'can create package';
export const CAN_CREATE_PROCURING_ENTITY = 'can create procuring-entity';
export const CAN_CREATE_SAFEGUARD_CONCERN = 'can create ohs and safeguard';
export const CAN_CREATE_REPORT = 'can create report';
export const CAN_CREATE_FIELD_NOTE = 'can create field note';
export const CAN_CREATE_USER = 'can create user';
export const CAN_CREATE_ROLE = 'can create role';
//new Create Permissions
export const CAN_CREATE_CSC_CONTRACT = 'can create csc contract';
export const CAN_CREATE_DOCUMENT = 'can create document';
export const CAN_CREATE_PERMISSION = 'can create permission';
export const CAN_CREATE_EXCEPTION = 'can create exception';
export const CAN_CREATE_MAP = 'can create map';
export const CAN_CREATE_STAFF = 'can create staff';
export const CAN_CREATE_ACCESS_CONTROL = 'can create access control';
export const CAN_CREATE_PIT_USER = 'can create pit user';
export const CAN_CREATE_PCT_USER = 'can create pct user';



// Update permissions
export const CAN_UPDATE_PROJECT = 'can update project';
export const CAN_UPDATE_SUB_PROJECT = 'can update sub-project';
export const CAN_UPDATE_PACKAGE = 'can update package';
export const CAN_UPDATE_PROCURING_ENTITY = 'can update procuring-entity';
export const CAN_UPDATE_SAFEGUARD_CONCERN = 'can update ohs and safeguard';
export const CAN_UPDATE_REPORT = 'can update report';
export const CAN_UPDATE_FIELD_NOTE = 'can update field note';
export const CAN_UPDATE_USER = 'can update user';
export const CAN_UPDATE_ROLE = 'can update role';
//new Update Permissions
export const CAN_UPDATE_CSC_CONTRACT = 'can update csc contract';
export const CAN_UPDATE_DOCUMENT = 'can update document';
export const CAN_UPDATE_PERMISSION = 'can update permission';
export const CAN_UPDATE_EXCEPTION = 'can update exception';
export const CAN_UPDATE_MAP = 'can update map';
export const CAN_UPDATE_STAFF = 'can update staff';
export const CAN_UPDATE_ACCESS_CONTROL = 'can update access control';
export const CAN_REPROCESS_SUBMISSION = 'can reprocess submission';



// Delete permissions
export const CAN_DELETE_PROJECT = 'can delete project';
export const CAN_DELETE_SUB_PROJECT = 'can delete sub-project';
export const CAN_DELETE_PACKAGE = 'can delete package';
export const CAN_DELETE_PROCURING_ENTITY = 'can delete procuring-entity';
export const CAN_DELETE_SAFEGUARD_CONCERN = 'can delete ohs and safeguard';
export const CAN_DELETE_REPORT = 'can delete report';
export const CAN_DELETE_FIELD_NOTE = 'can delete field note';
export const CAN_DELETE_USER = 'can delete user';
export const CAN_DELETE_ROLE = 'can delete role';
//new Delete Permissions
export const CAN_DELETE_CSC_CONTRACT = 'can delete csc contract';
export const CAN_DELETE_DOCUMENT = 'can delete document';
export const CAN_DELETE_PERMISSION = 'can delete permission';
export const CAN_DELETE_EXCEPTION = 'can delete exception';
export const CAN_DELETE_MAP = 'can delete map';
export const CAN_DELETE_STAFF = 'can delete staff';
export const CAN_DELETE_ACCESS_CONTROL = 'can delete access control';


// manage docmnt
export const CAN_DOWNLOAD_DOCUMENT = 'can download document';
export const CAN_APPROVE_DOCUMENT = 'can approve document';